var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_DOISER_REQUEST, GET_DOISER_REQUEST_ERROR, GET_DOISER_REQUEST_SUCCESS } from "../actions/getDoiser";
export var initialState = {
    isFetching: false,
    isError: false,
    data: [],
};
export function getDoiser(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_DOISER_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_DOISER_REQUEST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_DOISER_REQUEST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
//# sourceMappingURL=getDoiser.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_DOISER_REQUEST, GET_DOISER_REQUEST_ERROR, GET_DOISER_REQUEST_SUCCESS } from "../actions/getDoiser";
export var initialState = {
    isFetching: false,
    isError: false,
    data: [],
};
export function getDoiser(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_DOISER_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_DOISER_REQUEST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_DOISER_REQUEST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
//# sourceMappingURL=getDoiser.js.map